import MatchDetailsTabModel from '../common/model-match-details-tab';
import MatchDetailsOddModel from '../common/model-match-details-odd';
import MatchDetailsOutcomeModel from '../common/model-match-details-outcome';
import PlayerTabModel from 'bto-models/match/details/player/player-tab.model';
import { checkEnrichedName } from 'bto-models/utils/string';

/**
 * Live Match Details Model
 */
export default class MatchDetailsLiveModel {
  constructor(data, betItems = {}, selectedBetItems = [], liveGroupTabs = []) {
    /**
     * create reference to this data so we can use it for cloning
     * @type {object}
     */
    this.data = data;
    /**
     * Live match indicator
     */
    this.isLiveMatch = true;
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = data.HomeTeam;
    /**
     * Home team icon
     * @type {string}
     */ 
    this.homeTeamIcon = data.HomeTeamIcon ? `${APP_SETTINGS.path.teamImageUrl}${data.HomeTeamIcon}` : '';
    /**
     * Guest team name
     * @type {string}
     */
    this.guestTeam = data.AwayTeam;
    /**
     * Guest team icon
     * @type {string}
     */
    this.guestTeamIcon = data.AwayTeamIcon ? `${APP_SETTINGS.path.teamImageUrl}${data.AwayTeamIcon}` : '';
    /**
     * Sport ID
     * @type {number}
     */
    this.sportId = data.SportID;
    /**
     * Sport -> Category ID
     * @type {number}
     */
    this.categoryId = data.CategoryID;
    /**
     * Category name
     */
    this.categoryName = data.CategoryName;
    /**
     * Sport -> Category -> Tournament ID
     * @type {number}
     */
    this.tournamentId = data.TournamentID;
    /**
     * Tournament name
     */
    this.tournamentName = data.TournamentName;
    /**
     * Sport -> Category -> Tournament -> Match ID
     * @type {number}
     */
    this.matchId = data.MatchID;
    /**
     * Match ID from betradar
     * @type {number}
     */
    this.betRadarId = Number.parseInt(data.BetRadarID, 10);
    /**
     * Match time
     */
    this.time = Number.parseInt(data.MatchTime, 10);
    /**
     * Match status
     */

    this.status = data.MatchStatus;
    // match score
    this.setScore(data.GameScore);
    /**
     * Match betstop
     */
    this.isBetStop = data.IsBetStop;

    this.awayAtHome = data.TournamentUSlayout;
    /**
     * Match Event Code
     * @type {number}
     */
    this.eventCode = data.EventCode;
    /**
     * Suspended match
     * @type {boolean}
     */
    this.suspended = data.Suspended;

    this.streamId = data.StreamID;

    this.brokerId = Number(data.BrokerID);

    this.hasLiveStream = data.HaveLiveChannel;
    /**
     * Match markets + nested odds, outcomes
     * @type {array}
     */
    this.tabs = [];

    this.playerMarketsTab = {};

    let tabIdx = 1;
    let marketMap = {};
    let duplicateMarketMap = {};

    if(data.LiveOddTypes && data.LiveOddTypes.length){
      const playerMarketsTabModel = {				
        t: [{
            id: 0,
            is: 0,
            n: "Player Markets",
            o: [],
          }],
        pmd: data.pmd
      }; 
      const playerOutcomes = this.playerMarketOutcomeModel(data.LiveOddTypes.filter(oddType => oddType.IsPlayerMarket)) || [];
      if(playerOutcomes.length){
        playerMarketsTabModel.pmd.p = this.createOutcomeMap(playerOutcomes);
        playerMarketsTabModel.t[0].o = playerOutcomes;
        this.playerMarketsTab = new PlayerTabModel(playerMarketsTabModel);
      }      
    }

    data.LiveOddTypes && data.LiveOddTypes.sort((a, b) => a.Order > b.Order).forEach((datapoint) => {
     if(datapoint.IsPlayerMarket){ return; }
      let odd = new MatchDetailsOddModel({
        id: datapoint.LiveOddTypeID,
        n: checkEnrichedName(
          datapoint.EnrichedMarketName,
          data.HomeTeam,
          data.AwayTeam,
          datapoint.Sbv
        ) || datapoint.Name,
        c: null,
        ca: datapoint.Cashout,
        dm: datapoint.DescriptionMarket,
      }, data.HomeTeam, data.AwayTeam);

      let outcomes = [];
      datapoint.Outcomes.forEach(outcome => {
        const out = new MatchDetailsOutcomeModel({
          id: outcome.LiveOddTypeOutcomeID,
          n: outcome.Outcome,
          o: outcome.Odd,
          col: outcome.Column,
          ord: outcome.Order,
          ud: outcome.UpDown,
          sbv: outcome.Sbv,
          i: outcome.Identifier,
          sp: outcome.Specifier,
          a: outcome.Active,
          su: outcome.Suspended,
          eon: outcome.EnrichedOutcomeName,
        }, data.HomeTeam, data.AwayTeam);
        outcomes.push(out);
        const betItemKey = `${data.MatchID}_${odd.marketId}_${out.id}`;
        if (betItems[betItemKey]) {
          const oddChanged = (+out.originalDecimalOutcome) - (+betItems[betItemKey].odd) !== 0;
          const isLocked = data.isBetStop || data.Suspended || out.suspended || !out.active;
          if (isLocked || oddChanged) {
            selectedBetItems.push({ isBetStop: isLocked, newOdd: out.originalDecimalOutcome, item: betItems[betItemKey] });
          }
        }
      });
      odd.outcomes = outcomes;

      let tab = new MatchDetailsTabModel({
        id: tabIdx,
        n: checkEnrichedName(
          datapoint.EnrichedMarketName,
          data.HomeTeam,
          data.AwayTeam,
          datapoint.Sbv
        ) || datapoint.Name,
        d: "",
      }, data.SportID, data.HomeTeam, data.AwayTeam);
      tab.odds = [odd];
      this.tabs.push(tab);
      tabIdx += 1;
      marketMap[odd.marketId] = odd;
    });
    if (liveGroupTabs.length > 0) {
      this.tabs = liveGroupTabs.map((lgt, tabIdx) => {
        let tab = new MatchDetailsTabModel({
          id: tabIdx + 1,
          n: lgt.TabName,
          d: "",
        }, data.SportID, data.HomeTeam, data.AwayTeam);
        tab.odds = lgt.MatchTabLiveOddTypes.reduce((acc, tm) => {
          const sameIdMarkets = data.LiveOddTypes.filter(x => !x.IsPlayerMarket && x.LiveOddTypeID === tm.LiveOddTypeID);
          console.log('same',sameIdMarkets)
          if (sameIdMarkets.length === 1) {
            let key = `${marketMap[tm.LiveOddTypeID].marketName.replaceAll(" ", "")}_${tm.LiveOddTypeID}`;
            acc.push({
              ...marketMap[tm.LiveOddTypeID],
              isDuplicateMarket: duplicateMarketMap[key],
              isAutomaticSort: tm.IsAutomaticSort
            });
            if (key) duplicateMarketMap[key] = true;
          }
          if (sameIdMarkets.length > 1) {
            sameIdMarkets.forEach((x, idx) => {
              if(x.IsPlayerMarket){
                return
              }
              console.log("palyerMArket",x.IsPlayerMarket)
              let key = `${x.Name.replaceAll(" ", "")}_${tm.LiveOddTypeID}`;
              const market = new MatchDetailsOddModel({
                id: sameIdMarkets[idx].LiveOddTypeID,
                n: checkEnrichedName(
                  sameIdMarkets[idx].EnrichedMarketName,
                  data.HomeTeam,
                  data.AwayTeam,
                  sameIdMarkets[idx].Sbv
                ) || sameIdMarkets[idx].Name,
                c: null,
                ca: sameIdMarkets[idx].Cashout,
                dm: sameIdMarkets[idx].DescriptionMarket,
              }, data.HomeTeam, data.AwayTeam);
              let outcomes = [];
              sameIdMarkets[idx].Outcomes.forEach(outcome => {
                const out = new MatchDetailsOutcomeModel({
                  id: outcome.LiveOddTypeOutcomeID,
                  n: outcome.Outcome,
                  o: outcome.Odd,
                  col: outcome.Column,
                  ord: outcome.Order,
                  ud: outcome.UpDown,
                  sbv: outcome.Sbv,
                  i: outcome.Identifier,
                  sp: outcome.Specifier,
                  a: outcome.Active,
                  su: outcome.Suspended,
                  eon: outcome.EnrichedOutcomeName,
                }, data.HomeTeam, data.AwayTeam);
                outcomes.push(out);
                const betItemKey = `${data.MatchID}_${market.marketId}_${out.id}`;
                if (betItems[betItemKey]) {
                  const oddChanged = (+out.originalDecimalOutcome) - (+betItems[betItemKey].odd) !== 0;
                  const isLocked = data.isBetStop || data.Suspended || out.suspended || !out.active;
                  if (isLocked || oddChanged) {
                    selectedBetItems.push({ isBetStop: isLocked, newOdd: out.originalDecimalOutcome, item: betItems[betItemKey] });
                  }
                }
              });
              market.outcomes = outcomes;
              acc.push({
                ...market,
                isDuplicateMarket: duplicateMarketMap[key],
                isAutomaticSort: tm.IsAutomaticSort
              });
              if (key) duplicateMarketMap[key] = true;
            })
          }
          return acc;
        }, []);
        return tab;
      }).filter(t => t.odds.length > 0);

      const markets = Object.values(marketMap);
      Object.keys(marketMap).forEach((mid, idx) => {
        if (!duplicateMarketMap[markets[idx].extraId]) {
          const market = marketMap[mid];
          let tab = new MatchDetailsTabModel({
            id: this.tabs.length + idx,
            n: market.marketName,
            d: '',
            ca: market.cashout,
          });
          tab.odds = [market];
          this.tabs.push(tab);
        }
      });
    }

    let odds = this.tabs[0] !== undefined ? this.tabs[0].odds : [];
    this.odds = odds;
    this.name = this.getName(data);
  }

  playerMarketOutcomeModel(originalArray) {
    return originalArray.map(item => ({
        c: item.ColumnMax,
        id: item.LiveOddTypeID,
        m: item.Outcomes.map(outcome => ({
            col: outcome.Column,
            eon: outcome.EnrichedOutcomeName,
            id: outcome.LiveOddTypeOutcomeID,
            n: outcome.Outcome,
            o: outcome.Odd,
            ord: outcome.Order,
            su: outcome.Suspended,
            ud: outcome.UpDown,
            sbv: outcome.Sbv,
            a: outcome.Active,
            i: outcome.Identifier,
            sp: outcome.Specifier,
            pn: outcome.PlayerName,
            ps: outcome.PlayerSide
        })),
        n: item.Name,
        oti: item.MarketIdMapMongoDB
    }));
  }

  createOutcomeMap(playerOutcomes) {
    return playerOutcomes.reduce((acc, outcome) => {
      outcome.m.forEach(item => {
        if (!item.pn || !item.ps || acc[item.n]) {
          return;
        }  
        acc[item.n] = {
          n: item.pn,
          t: item.ps
        };
      });
      return acc;
    }, {});
  }

  getName(data) {
    if (data.TournamentUSlayout) {
      return `${this.guestTeam} @ ${this.homeTeam}`;
    }
    return `${this.homeTeam} vs ${this.guestTeam}`;
  }

  setScore(score) {
    this.score = {
      home: '--',
      away: '--',
    };
    if (score) {
      let matchScore = score.split(':');
      this.score.home = matchScore[0] || '--';
      this.score.away = matchScore[1] || '--';
    }
  }
  /**
   * Map US markets
   * @param {{[id:string]:string}} markets - map of marketId -> market Name
   */
  mapMarkets(markets) {
    if (!markets) {
      return [];
    }
    return Object.entries(markets).map(([id, name]) => ({ id, name }));
  }
  /**
   * Create new copy of this model with same data
   * this way we are creating deep copy of this object
   * @returns {MatchDetailsLiveModel}
   */
  clone() {
    return new MatchDetailsLiveModel(this.data);
  }
}
